(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultReportDetailController', ResultReportDetailController);

    ResultReportDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'ResultReport', 'Result'];

    function ResultReportDetailController($scope, $rootScope, $stateParams, DataUtils, entity, ResultReport, Result) {
        var vm = this;

        vm.resultReport = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('portalApp:resultReportUpdate', function(event, result) {
            vm.resultReport = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
